import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';

const OpenDoorAnimated = ({
  color = '#ffffff',
  width = 27,
  height = 15,
  verticalAlign = 'bottom',
}) => {
  const svgRef = useRef(null);
  const doorRef = useRef(null);

  const yPos = verticalAlign === 'center' ? 7.5 : 12;

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ paused: true });

      tl.to(doorRef.current, {
        rotate: -45,
        transformOrigin: '0px 0px',
        duration: 0.3,
        ease: 'power2.out',
      });

      gsap.matchMedia().add('(hover: hover)', () => {
        const el =
          svgRef.current.closest('.button') || svgRef.current.closest('a');

        if (!el) return;

        const onEnter = () => tl.play();
        const onLeave = () => tl.reverse();

        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('mouseleave', onLeave);

        return () => {
          el.removeEventListener('mouseenter', onEnter);
          el.removeEventListener('mouseleave', onLeave);
        };
      });
    }, svgRef);

    return () => ctx.revert();
  }, []);

  return (
    <svg
      ref={svgRef}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 27 15'
      fill='none'
      style={{ overflow: 'visible', pointerEvents: 'none', display: 'block' }}
    >
      <line
        x1='0'
        y1={yPos}
        x2='9'
        y2={yPos}
        stroke={color}
        strokeWidth='1.5'
      />
      <g ref={doorRef} transform={`translate(9, ${yPos})`}>
        <line x1='0' y1='0' x2='9' y2='0' stroke={color} strokeWidth='1.5' />
      </g>
      <line
        x1='18'
        y1={yPos}
        x2='27'
        y2={yPos}
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
};

export default OpenDoorAnimated;
